import React from 'react'
import { observer, inject } from 'mobx-react'

const Logout = ({ authStore }) => {
  return (
    <div className='header__logged__item' onClick={ authStore.logout }>
      <i className='fas fa-sign-out-alt' />
    </div>
  )
}

export default inject('authStore')(observer(Logout))



// WEBPACK FOOTER //
// ./src/components/Header/LoggedInHeader/Logout.js